import api from './axiosConfig';

export interface AttendanceLogDto {
  id: string;
  organization: string;
  employeeCode: string;
  employeeName: string;
  date: string;
  time: string;
  type: string;
  modeOfEntry: string | null;
  locationName: string | null;
  viewLocation: string | null;
  entityName: string | null;
  entityType: string | null;
  reasonProvided: string | null;
  recordedBy: string | null;
  remarks: string | null;
  department: string | null;
  designation: string | null;
  branch: string | null;
}

export interface AttendanceLogsResult {
  data: AttendanceLogDto[];
  total: number;
  pageNumber: number;
  pageSize: number;
}

export interface AttendanceLogsFilters {
  employeeId?: string;
  startDate?: string;
  endDate?: string;
  type?: string;
  modeOfEntry?: string;
  locationName?: string;
  entityType?: string;
  departmentId?: string;
  designationId?: string;
  branchId?: string;
  entityName?: string;
  recordedBy?: string;
  remarks?: string;
  groupBy?: string;
  pageNumber?: number;
  pageSize?: number;
}

const cleanString = (value?: string) => {
  const trimmed = value?.trim();
  return trimmed ? trimmed : undefined;
};

const buildAttendanceLogParams = (filters: AttendanceLogsFilters): AttendanceLogsFilters => ({
  employeeId: cleanString(filters.employeeId),
  startDate: filters.startDate,
  endDate: filters.endDate,
  type: cleanString(filters.type),
  modeOfEntry: cleanString(filters.modeOfEntry),
  locationName: cleanString(filters.locationName),
  entityType: cleanString(filters.entityType),
  departmentId: cleanString(filters.departmentId),
  designationId: cleanString(filters.designationId),
  branchId: cleanString(filters.branchId),
  entityName: cleanString(filters.entityName),
  recordedBy: cleanString(filters.recordedBy),
  remarks: cleanString(filters.remarks),
  groupBy: cleanString(filters.groupBy),
  pageNumber: filters.pageNumber,
  pageSize: filters.pageSize,
});

export const activityLogsApi = {
  getAttendanceLogs: async (filters: AttendanceLogsFilters): Promise<AttendanceLogsResult> => {
    const response = await api.get<AttendanceLogsResult>('/attendance/logs', { params: buildAttendanceLogParams(filters) });
    return response.data;
  },

  exportAttendanceLogs: async (filters: Omit<AttendanceLogsFilters, 'pageNumber' | 'pageSize' | 'groupBy'>): Promise<Blob> => {
    const response = await api.get('/attendance/logs/export', {
      params: buildAttendanceLogParams(filters),
      responseType: 'blob',
    });
    return response.data;
  },
};
